module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-4.cd97295f.png";